import { z } from 'zod';
import { DISCOUNT_KIND } from '../../discountKind';
import { DISCOUNT_USAGE_KIND } from '../../discountTerms';
import { refinePromotionDealFields } from '../../promotionDealValidation';

export const createCouponSchema = z
  .object({
    discountKind: z.enum([DISCOUNT_KIND.amount, DISCOUNT_KIND.percentage]),
    discountAmount: z.number().nullable(),
    discountPercentage: z.number().nullable(),
    expiresAt: z.date().nullish(),
    userGroupId: z.number().nullable(),
    appliesToAllProducts: z.boolean(),
    filterByProducts: z.boolean(),
    filterByTags: z.boolean(),
    salesItemIds: z.array(z.number()),
    salesItemTagIds: z.array(z.number()),
    usageKind: z.enum([DISCOUNT_USAGE_KIND.once, DISCOUNT_USAGE_KIND.limited, DISCOUNT_USAGE_KIND.forever]),
    maxUsesCount: z.number().nullable()
  })
  .superRefine((value, ctx) => {
    if (value.userGroupId === null) {
      ctx.addIssue({ code: 'custom', message: 'Customer is required', path: ['userGroupId'] });
    }
    refinePromotionDealFields(value, ctx);
    if (value.usageKind === DISCOUNT_USAGE_KIND.limited && (value.maxUsesCount == null || value.maxUsesCount < 1)) {
      ctx.addIssue({ code: 'custom', message: 'Enter number of uses', path: ['maxUsesCount'] });
    }
  });

export type CreateCouponFormValues = z.input<typeof createCouponSchema>;
